type StartProposalCopyDetails = {
  label: string;
  tooltip: string;
};

export const useStartProjectCopy = (): StartProposalCopyDetails => {
  return {
    label: 'Start project',
    tooltip: 'Create and send a project proposal to your Client.',
  };
};
